import { cloneDeepWith } from 'lodash'

// Canvas cannot resolve CSS custom properties, so chart colors are expressed as
// token references (`var(--color-brand)`) and resolved by EChart every time it
// applies an option, including after a theme change. DOM consumers can use the
// references as-is, and `opacity` or `color-mix()` where an alpha is needed.
export const CHART = {
  BRAND: 'var(--color-brand)',
  BRAND_TEXT: 'var(--color-text-brand)',
  BRAND_BG: 'var(--color-background-brand)',
  BRAND_SOFT: 'var(--color-background-brand-hover)',
  CRITICAL: 'var(--color-critical)',
  CRITICAL_BG: 'var(--color-background-critical)',
  SUCCESS: 'var(--color-success)',
  SUCCESS_BG: 'var(--color-background-success)',
  WARNING: 'var(--color-warning)',
  CAUTION: 'var(--color-caution)',
  INFORMATIVE: 'var(--color-informative)',
  MAGICAL: 'var(--color-magical)',
  MUTED: 'var(--color-neutral)',
  SUCCESS_HOVER: 'var(--color-success-hover)',
  TEXT: 'var(--color-text)',
  TEXT_SECONDARY: 'var(--color-text-secondary)',
  TEXT_MUTED: 'var(--color-text-muted)',
  TEXT_ON_FILL: 'var(--color-text-on-fill)',
  BORDER: 'var(--color-border)',
  SURFACE: 'var(--color-background-surface)',
  HOVER_OVERLAY: 'var(--color-hover-overlay)',
  LOADING_MASK: 'var(--color-background-loading)',
}

const TOKEN_REFERENCE = /^var\((--[\w-]+)\)$/

// Walks an ECharts option (or theme) and resolves every token reference to its
// current value.
export const resolveChartColors = (value) => {
  const styles = getComputedStyle(document.documentElement)
  return cloneDeepWith(value, (entry) => {
    const token = typeof entry === 'string' && entry.match(TOKEN_REFERENCE)
    return token ? styles.getPropertyValue(token[1]).trim() || entry : undefined
  })
}
